<template>
  <b-modal id="individual-view-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span aria-hidden="true" @click="isViewMode = !isViewMode;" v-if="canSwitch">
          <img src="/images/pencil.svg" alt="" />
        </span>
        <span class="modal-title adp-h2 adp-h2__modal" v-if="isViewMode">{{ $t('voc.view_individual_education') }}</span>
        <span class="modal-title adp-h2 adp-h2__modal" v-else>{{ $t('voc.edit_individual_education') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="isViewMode && !isLoading">
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.name') }}</div>
        <div class="adp-p">{{ name }}</div>
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.type') }}</div>
        <div class="adp-p">{{ $t(`idp.${ttype}`) }}</div>
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.author') }}</div>
        <div class="adp-p">{{ $t(whoCreatedEvent) }}</div>
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.format') }}</div>
        <div class="adp-p">{{ $t(`idp.${format_method}`) }}</div>
      </div>
      <template v-for="(competence, i) in competencies">
        <div class="adp-modal-row adp-modal-competence-block">
          <div>
            <div class="adp-p adp-p__grey">{{ $t('catalog.competencies') }}</div>
            <div class="adp-p">{{ competence[`name`] }}</div>
          </div>
        </div>
      </template>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.when') }}</label>
        <div class="adp-p">{{ deadline ? formatDate(deadline) : '-' }}</div>
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.provider') }}</div>
        <div class="adp-p">{{ provider ? providerOptions.find(x => x.code === provider).label : '-' }}</div>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.link') }}</label>
        <div class="adp-p">{{ link ? link : '-' }}</div>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.comment') }}</label>
        <div class="adp-p">{{ comment ? comment : '-' }}</div>
      </div>
    </template>
    <template v-if="!isViewMode && !isLoading">
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.name') }}</label>
        <input type="text" v-model="name" class="adp-input adp-input__text" :placeholder="$t('catalog.name_placeholder')">
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.type') }}</div>
        <div class="adp-p">{{ $t('idp.individual') }}</div>
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.author') }}</div>
        <div class="adp-p">{{ $t(whoCreatedEvent) }}</div>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.format') }}</label>
        <v-select :options="formatMethodOptions" v-model="format_method" :reduce="option => option.code"
                  :placeholder="$t('catalog.choose_format_method')">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>
      <template v-for="(competence, i) in competencies">
        <competence-skills-block v-on:select-competence="onSelectCompetencies($event, i)"
                                 v-on:delete-competence="onDeleteCompetence($event, i)"
                                 :has-delete-button="i !== 0"
                                 :competence-obj="competence"
                                 :competence-options="competenceOptions"
                                 :key="i" />
      </template>
      <div class="btn adp-btn-outline" @click="() => (competencies.push(null))">
        + {{ competencies.length > 1 ? $t('catalog.add_another_competence') : $t('catalog.add_competence') }}
      </div>
      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">{{ $t('catalog.when') }}</label>
        <my-date-picker v-on:change="changeDateInterval($event)" :dates="when"></my-date-picker>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.provider') }}</label>
        <v-select :options="providerOptions" v-model="provider" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.link_edit') }}</label>
        <input type="text" v-model="link" class="adp-input adp-input__text">
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.comment') }}</label>
        <textarea rows="5" v-model="comment" class="adp-input adp-input-textarea" :placeholder="$t('modal.comment_placeholder')"></textarea>
      </div>
    </template>
    <template #modal-footer v-if="isViewMode">
      <span>&nbsp;</span>
    </template>
    <template #modal-footer v-else>
      <button id="delete" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import CompetenceSkillsBlock from "./../CompetenceSkillsBlock";
import api from "../../api";
import Vue from "vue";
import MyDatePicker from "../MyDatePicker";
import {modifyCompetences} from "../../updateUrl";

export default {
  name: "IndividualViewModal",
  components: {
    'competence-skills-block': CompetenceSkillsBlock,
    'my-date-picker': MyDatePicker,
  },
  props: {
    learningActivityId: {
      type: Number,
      required: true,
    },
    activityId: {
      type: Number,
      required: true,
    },
    activityType: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      isViewMode: true,
      isLoading: false,

      ttype: 'individual',
      name: '',
      category: '',
      format_method: '',
      personal_type: '',
      competencies: [],
      deadline: '0000-00-00',
      purpose: '',
      comment: '',
      provider: '',
      link: '',
      authorPernumber: '',
      authorRole: '',
      currentRole: '',

      when: new Date(),

      formatMethodOptions: [],

      competenceOptions: [],
      defaultCompetenceList: [],
      providerOptions: [],
    }
  },
  computed: {
    canSwitch() {
      if (this.isEditable && this.currentRole === this.authorRole && this.authorRole === 'employee') return false;
      if (this.isEditable && this.currentRole === 'employee' && this.authorRole !== 'employee') return false;
      if (this.isEditable && this.currentRole === 'hr' && this.authorRole !== 'hr') return false;
      if (this.currentRole === 'manager') return false;
      return true;
    },
    whoCreatedEvent() {
      if (this.currentRole !== this.authorRole && this.authorRole === 'hr') return 'modal.created_by_hr';
      if (this.currentRole !== this.authorRole && this.authorRole === 'manager') return 'modal.created_by_manager';
      if (this.currentRole !== this.authorRole && this.authorRole === 'employee') return 'modal.created_by_employee';

      return 'modal.created_by_you';
    }
  },
  methods: {
    onSelectCompetencies(competenceObj, i) {
      this.competencies[i] = competenceObj;

      this.$nextTick(() => {
        this.competenceOptions = this.defaultCompetenceList;
        this.competencies.forEach((competence) => {
          this.competenceOptions = this.competenceOptions.filter(c => c.id !== competence.id);
        })
      })
    },
    onDeleteCompetence(e, index) {
      Vue.delete(this.competencies, index);

      this.$nextTick(() => {
        this.competenceOptions = this.defaultCompetenceList;
        this.competencies.forEach((competence) => {
          this.competenceOptions = this.competenceOptions.filter(c => c.id !== competence.id);
        })
      })
    },
    changeDateInterval(e) {
      if (e === null) {
        return;
      }
      this.when = e;
    },
    async onShow() {
      this.isLoading = true;
      this.isViewMode = false;
      await (async () => {
        let res = await api.getLearningActivity(this.activityType, this.activityId);
        this.ttype = this.activityType;
        this.name = res.data.name;
        this.category = res.data.category;
        this.format_method = res.data.format_method;
        this.personal_type = res.data.personal_type;
        this.competencies = res.data.competencies;
        this.deadline = res.data.deadline;
        this.when = res.data.deadline ? new Date(res.data.deadline) : null;
        this.purpose = res.data.purpose;
        this.comment = res.data.comment;
        this.authorPernumber = res.data.author_pernumber;
        this.authorRole = res.data.author_role;
        this.currentRole = window.IDP.role;

        this.provider = res.data.provider;
        this.link = res.data.link;

        this.formatMethodOptions = window.IDP.formatMethod
          // .filter(e => String(e).startsWith(this.personal_type === 'common_employee' ? 'f' : 'm'))
          .map((e) => {
            return {code: e, label: this.$t(`idp.${e}`)}
          });

        this.competencies.forEach((competence) => {
          this.competenceOptions = this.competenceOptions.filter(c => c.id !== competence.id);
        })
      })();

      if (this.currentRole === 'employee' && this.authorRole !== 'employee') this.isViewMode = true;
      if (this.currentRole === 'hr' && this.authorRole !== 'hr') this.isViewMode = true;
      if (this.currentRole === 'manager' && this.authorRole !== 'manager') this.isViewMode = true;

      this.isLoading = false;
    },
    async save() {
      let data = {
        id: this.activityId,
        type: this.ttype,
        name: this.name,
        format_method: this.format_method,
        competences: modifyCompetences(this.competencies),
        deadline: this.when ? new Date(this.when).toLocaleString() : null,
        comment: this.comment,
        provider: this.provider,
        link: this.link,
      };
      try {
        let resp = await api.editIndividualEvent(data);
        if (resp.status === 201) {
          this.$emit('individual-updated');
        }
      } catch (e) {
        console.error(e.response.data);
        const serverErrors = Object.keys(e.response.data.errors).map(x => `• ${this.$t('catalog.' + x)}`).join('\n');
        const errorText = this.$t('modal.error_individual_modal_1') + '\n' +
          this.$t('modal.error_individual_modal_2') + '\n\n' +
          this.$t('modal.error_individual_modal_3') + '\n\n' +
          serverErrors;
        this.$toasts.error(errorText, {
          duration: 700000,
        });
      }
    },
    formatDate(input) {
      let datePart = input.match(/\d+/g);
      const year = datePart[0];
      const month = datePart[1];
      const day = datePart[2];

      return day + '.' + month + '.' + year;
    },
    async fetchCompetences() {
      try {
        const response = await api.searchCompetences('');
        this.defaultCompetenceList = response;
        this.competenceOptions = response;
      } catch (e) {
        console.log(e);
      }
    },
    async getProviders() {
      try {
        let res = await api.getProviders();
        this.providerOptions = res.data.data.map(el => {
          return {
            code: el.id,
            label: el[`name_${this.$i18n.locale}`],
          };
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.fetchCompetences();
    this.getProviders();
  }
}
</script>
